import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ForkliftDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftDto';
import { AccessControlGatePlateDto } from '@shared/src/dtos/accesscontrol/gate/plate/AccessControlGatePlateDto';

@Component({
    selector: 'shared-forklift-left-route',
    templateUrl: './shared.forklift.left.route.component.html',
    styleUrls: ['./shared.forklift.left.route.component.scss']
})
export class SharedForkliftLeftRouteComponent {

    @Input() public value: AccessControlGatePlateDto;
    @Output() public clickRoute = new EventEmitter<AccessControlGatePlateDto>();

    public pretty(value: any): string {
        return JSON.stringify(value);
    }
}
